import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  Layout,
  Card,
  Form,
  Input,
  Checkbox,
  Select,
  Button,
  Modal,
  Spin,
} from "antd";
import {
  GlobalOutlined,
  AppstoreFilled,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import {
  repeatOptions,
  responseOptions,
  alertTimeOptions,
} from "../../constants/config";
import { getContacts } from "../../services/user";
import {
  createServer,
  getDetailServer,
  updateServer,
  checkServer,
} from "../../services/server";
import languages from "../../constants/languages";

const defaultForm = { path: "/", web_https: false };

export const ServerForm = (props) => {
  const [contacts, setContacts] = useState(null);
  const [fields, setFields] = useState(null);
  const [id, setId] = useState(null);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedContact, setSelectedContact] = useState([]);
  const [status, setStatus] = useState(null);

  const [form] = Form.useForm();

  //submit form
  const onFinish = (values) => {
    let alert_address_ids = values.contact_1 ? values.contact_1 : "";

    if (values.contact_2) {
      alert_address_ids += alert_address_ids ? "," + values.contact_2 : "";
    }

    if (values.contact_3) {
      alert_address_ids += alert_address_ids
        ? "," + values.alert_address_ids
        : "";
    }

    const params = {
      ...values,
      alert_address_ids,
      content: values.content
        ? encodeURIComponent(values.content)
        : values.content,
      path: values.path ? encodeURIComponent(values.path) : values.path,
      domain: values.domain ? encodeURIComponent(values.domain) : values.domain,
    };

    if (!id) {
      createNewServer(params);
    } else {
      updateServerById(params);
    }
  };

  const onClickCancel = () => {
    props.history.push(`${process.env.PUBLIC_URL}/server/list`);
  };

  const onClickCheckServer = () => {
    setLoading(true);
    const values = {
      ...form.getFieldsValue(),
      _id: id,
    };

    checkServer(values).then((res) => {
      if (res.status === 1) {
        setVisible(true);
        setStatus(res.data);
        //toast.success(languages.add_server_success);
        //props.history.push(`${process.env.PUBLIC_URL}/server/list`);
      } else {
        toast.error(
          <>
            {res.message.map((mes, index) => {
              return <p key={index}>{mes.msg}</p>;
            })}
          </>
        );
      }
      setLoading(false);
    });
  };

  const createNewServer = (params) => {
    createServer(params).then((res) => {
      if (res.status === 1) {
        toast.success(languages.add_server_success);
        props.history.push(`${process.env.PUBLIC_URL}/server/list`);
      } else {
        toast.error(
          <>
            {res.message.map((mes, index) => {
              return <p key={index}>{mes.msg}</p>;
            })}
          </>
        );
      }
    });
  };

  // pause server
  const updateServerById = (params) => {
    updateServer(id, params).then((res) => {
      if (res.status === 1) {
        toast.success(languages.update_server_success);
        props.history.push(`${process.env.PUBLIC_URL}/server/list`);
      } else {
        toast.error(
          <>
            {res.message.map((mes, index) => {
              return <p key={index}>{mes.msg}</p>;
            })}
          </>
        );
      }
    });
  };

  useEffect(() => {
    getContacts().then((res) => {
      if (res.status === 1) {
        setContacts(res.data);
      }
    });
    return () => {
      setContacts([]);
    };
  }, []);

  // load detail server if isset id
  useEffect(() => {
    if (props.match && props.match.params && props.match.params.id) {
      setId(props.match.params.id);
      getDetailServer(props.match.params.id).then((res) => {
        if (res.status === 1) {
          setFields({
            ...res.data,
            contact_1: res.data.alert_address_ids[0],
            contact_2: res.data.alert_address_ids[1],
            contact_3: res.data.alert_address_ids[2],
          });
          setSelectedContact(res.data.alert_address_ids);
        } else {
          toast.error(res.message);
        }
      });
    } else {
      setFields(defaultForm);
    }
    // component unmount
    return () => {
      setFields(null);
    };
  }, [props.match.params.id]);

  const onContactChange = (index, value) => {
    const nContacts = contacts.map((item) =>
      item._id === value
        ? { ...item, index }
        : item.index === index
        ? { ...item, index: null }
        : item
    );

    setSelectedContact(
      nContacts.filter((item) => item.index).map((item) => item._id)
    );
    setContacts(nContacts);
  };

  const renderSelectContact = (idx) =>
    contacts.map((item) => {
      return (
        <Select.Option key={item._id} value={item._id}>
          {item.name}
        </Select.Option>
      );
    });

  if (!fields || !contacts) {
    return <div>loading...</div>;
  }

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <Layout className="layout-server">
      <Card title="監視サーバー">
        <div className="section-title">監視サーバー</div>
        <Form
          layout={"vertical"}
          form={form}
          initialValues={{
            layout: "vertical",
          }}
          onFinish={onFinish}
          className="server-form"
          initialValues={fields}
        >
          <Form.Item
            name="name"
            label={
              <div>
                監視設定名<span className="required-field">(必須)</span>
              </div>
            }
            wrapperCol={{ span: 7 }}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="domain"
            label={
              <div>
                監視サーバーアドレス
                <span className="required-field">(必須)</span>
              </div>
            }
            wrapperCol={{ span: 7 }}
          >
            <Input placeholder="FQDNを入力" />
          </Form.Item>

          <div className="section-title">
            監視サービス<span className="required-field">(必須)</span>
          </div>
          <Card
            title={
              <>
                <GlobalOutlined />
                Webサーバー
              </>
            }
            className="card-grey web-service"
          >
            <Form.Item name="web_ping" valuePropName="checked" noStyle>
              <Checkbox>Ping</Checkbox>
            </Form.Item>

            <div className="row">
              <div className="left">
                <Form.Item name="web_https" valuePropName="checked" noStyle>
                  <Checkbox>HTTPS (TCP443)</Checkbox>
                </Form.Item>
              </div>
              <div className="right">
                <Form.Item
                  name="content"
                  label={
                    <div>
                      文字列チェック
                      <span className="required-field">(必須)</span>
                    </div>
                  }
                  className="form-item-horizontal"
                  wrapperCol={{ span: 10 }}
                >
                  <Input placeholder="確認する文字列" />
                </Form.Item>
                <Form.Item
                  name="path"
                  label={
                    <div>
                      Path<span className="required-field">(必須)</span>
                    </div>
                  }
                  className="form-item-horizontal"
                  wrapperCol={{ span: 10 }}
                >
                  <Input />
                </Form.Item>
              </div>
            </div>
          </Card>
          <Card
            title={
              <>
                <AppstoreFilled />
                その他のサービス
              </>
            }
            className="card-grey"
          >
            <Form.Item name="smtp" valuePropName="checked" noStyle>
              <Checkbox>SMTP (TCP25)</Checkbox>
            </Form.Item>
            <Form.Item name="pop" valuePropName="checked" noStyle>
              <Checkbox>POP (TCP110)</Checkbox>
            </Form.Item>
            <Form.Item name="imap" valuePropName="checked" noStyle>
              <Checkbox>IMAP (TCP143)</Checkbox>
            </Form.Item>
            <Form.Item
              name="smtp_submitsion_port"
              valuePropName="checked"
              noStyle
            >
              <Checkbox>SMTP Submission Port (TCP587)</Checkbox>
            </Form.Item>
            <Form.Item name="ftp" valuePropName="checked" noStyle>
              <Checkbox>FTP (TCP21)</Checkbox>
            </Form.Item>
          </Card>
          <Form.Item
            name="repeat_time"
            label={
              <div>
                監視間隔<span className="required-field">(必須)</span>
              </div>
            }
            wrapperCol={{ span: 7 }}
            className="mt10"
          >
            <Select allowClear>
              {repeatOptions.map((item) => (
                <Select.Option key={item.value} value={item.value}>
                  {item.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="response_time"
            label={
              <div>
                正常とするレスポンスタイム
                <span className="required-field">(必須)</span>
              </div>
            }
            wrapperCol={{ span: 7 }}
          >
            <Select allowClear>
              {responseOptions.map((item) => (
                <Select.Option key={item.value} value={item.value}>
                  {item.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="is_resend_notification"
            valuePropName="checked"
            noStyle
          >
            <Checkbox>{languages.checkboxRepeatSendNotification}</Checkbox>
          </Form.Item>
          <Form.Item
            className="mt10"
            name="repeat_time_notification"
            label={
              <div>
                再通知間隔<span className="required-field">(必須)</span>
              </div>
            }
            wrapperCol={{ span: 7 }}
          >
            <Select allowClear>
              {alertTimeOptions.map((item) => (
                <Select.Option key={item.value} value={item.value}>
                  {item.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <div className="note">
            再通知間隔は再通知間隔以上の間隔に設定してください。再通知を無効化した場合はアラート検知が継続している場合もアラート通知は1度しか行われない
          </div>
          <div className="section-title">
            監視アラート連絡先<span className="required-field">(必須)</span>
          </div>
          <Form.Item
            wrapperCol={{ span: 7 }}
            className="mt10"
            label={
              <div>
                連絡先<span className="required-field">(必須)</span>
              </div>
            }
            name="contact_1"
          >
            <Select
              allowClear
              placeholder="選択してください。"
              onChange={(value) => onContactChange(1, value)}
              initialvalues={fields.contact_1}
            >
              {renderSelectContact(1)}
            </Select>
          </Form.Item>
          <Form.Item
            label="連絡先"
            wrapperCol={{ span: 7 }}
            className="mt10"
            name="contact_2"
          >
            <Select
              allowClear
              onChange={(value) => onContactChange(2, value)}
              initialvalues={fields.contact_2}
              placeholder="選択してください。"
            >
              {renderSelectContact(2)}
            </Select>
          </Form.Item>
          <Form.Item
            label="連絡先"
            wrapperCol={{ span: 7 }}
            className="mt10"
            name="contact_3"
          >
            <Select
              allowClear
              onChange={(value) => onContactChange(3, value)}
              initialvalues={fields.contact_3}
              placeholder="選択してください。"
            >
              {renderSelectContact(3)}
            </Select>
          </Form.Item>
          <Button type="primary" className="mr10" htmlType="submit">
            保存
          </Button>
          <Button onClick={onClickCancel}>キャンセル</Button>
          {id && (
            <Button
              type="primary"
              className="btn-success"
              onClick={onClickCheckServer}
              loading={loading}
            >
              この内容でサーバをチェック
            </Button>
          )}
        </Form>
      </Card>
      <Modal
        title="監視中サービスの現在の状態"
        visible={visible}
        onCancel={handleCancel}
        footer={null}
      >
        <div className="lable-status">Webサーバー:</div>
        {status && (
          <>
            <div className="lable-status">
              確認する文字列:
              {status.content ? (
                <CheckOutlined className="status-ok" />
              ) : (
                <CloseOutlined className="status-error" />
              )}
            </div>
            {status.content && !status.response_time && (
              <div className="lable-status">
                正常とするレスポンスタイム:
                {status.response_time ? (
                  <CheckOutlined className="status-ok" />
                ) : (
                  <CloseOutlined className="status-error" />
                )}
              </div>
            )}
            {form.getFieldValue().web_ping && (
              <div className="lable-status">
                Ping:
                {status.web_ping ? (
                  <CheckOutlined className="status-ok" />
                ) : (
                  <CloseOutlined className="status-error" />
                )}
              </div>
            )}
            {form.getFieldValue().web_https && (
              <>
                <div className="lable-status">
                  TCP443 (HTTPS Web):
                  {status.web_https ? (
                    <CheckOutlined className="status-ok" />
                  ) : (
                    <CloseOutlined className="status-error" />
                  )}
                </div>
              </>
            )}
            {form.getFieldValue().smtp && (
              <div className="lable-status">
                TCP25 (SMTP):
                {status.smtp ? (
                  <CheckOutlined className="status-ok" />
                ) : (
                  <CloseOutlined className="status-error" />
                )}
              </div>
            )}
            {form.getFieldValue().pop && (
              <div className="lable-status">
                TCP110 (POP):
                {status.pop ? (
                  <CheckOutlined className="status-ok" />
                ) : (
                  <CloseOutlined className="status-error" />
                )}
              </div>
            )}
            {form.getFieldValue().imap && (
              <div className="lable-status">
                TCP143 (IMAP):
                {status.imap ? (
                  <CheckOutlined className="status-ok" />
                ) : (
                  <CloseOutlined className="status-error" />
                )}
              </div>
            )}
            {form.getFieldValue().smtp_submitsion_port && (
              <div className="lable-status">
                TCP587 (SMTP Submitssion port):
                {status.smtp_submitsion_port ? (
                  <CheckOutlined className="status-ok" />
                ) : (
                  <CloseOutlined className="status-error" />
                )}
              </div>
            )}
            {form.getFieldValue().ftp && (
              <div className="lable-status">
                TCP21 (FTP):
                {status.ftp ? (
                  <CheckOutlined className="status-ok" />
                ) : (
                  <CloseOutlined className="status-error" />
                )}
              </div>
            )}
          </>
        )}
      </Modal>
    </Layout>
  );
};
